import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from '@reduxjs/toolkit/query'
import configReducer from "./configSlice"
import { yaroomsApi } from '../api/apiSlice'

export const Store = configureStore({
    reducer: {
        data: configReducer,
        [yaroomsApi.reducerPath]: yaroomsApi.reducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(yaroomsApi.middleware)
});

setupListeners(Store.dispatch)
